// Javascript implementation of Java's String.hashCode().
const stringToHashCode = str => {
  let hash = 0;
  if (str.length === 0) return hash;

  for (let i = 0; i < str.length; i += 1) {
    const char = str.charCodeAt(i);
    /* eslint-disable no-bitwise */
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer.
    /* eslint-enable */
  }

  return hash;
};

export default stringToHashCode;



// WEBPACK FOOTER //
// ../utils/functions/string-to-hash.js